import { emailRegex } from '../constants/regex';

export function isEmail(email: string): boolean {
  return emailRegex.test(email);
}
